/*
* Values lifted 1:1 from the compiled Limitless theme (bootstrap + bootstrap-limitless
* + limitless_timr overrides) so the primitive is visually identical to a Bootstrap 3
* `.modal` while owning its own CSS (no Bootstrap classes on a Base UI primitive).
* Bootstrap's `.fade`/`.in` enter/exit is re-mapped onto Base UI's
* `[data-starting-style]` / `[data-ending-style]` transition attributes.
*/

/* .modal-backdrop — solid black, fades to 0.5 */
.backdrop {
	position: fixed;
	inset: 0;
	z-index: var(--zindex-modal-background);
	background-color: var(--modal-backdrop-bg);
	opacity: var(--modal-backdrop-opacity);
	transition: opacity 0.15s linear;
}

.backdrop[data-starting-style],
.backdrop[data-ending-style] {
	opacity: 0;
}

/*
* Positioning + scroll container. Limitless sits the dialog 30px from the top,
* horizontally centred, and lets the whole viewport scroll past tall content.
*/
.viewport {
	position: fixed;
	inset: 0;
	z-index: var(--zindex-modal);
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: var(--modal-viewport-padding-y) var(--modal-viewport-padding-x);
	overflow-y: auto;
}

/* .modal-content — white card, 5px radius, soft shadow; default (md) width 600px */
.content {
	position: relative;
	width: var(--modal-md);
	max-width: 100%;
	background-color: var(--modal-content-bg);
	border-radius: var(--border-radius-base);
	box-shadow: var(--modal-content-shadow);
	background-clip: padding-box;
	/*
	* Clip children to the card's rounded shape so a coloured header background
	* follows the corners — including the squared-off inner corner produced by a
	* thick variation border. Base UI portals its own popups to <body>, so this
	* doesn't clip nested tooltips/menus.
	*/
	overflow: hidden;
	outline: 0;
	transition: opacity 0.3s ease-out,
	transform 0.3s ease-out;
}

/* .modal.fade .modal-dialog — slide down + fade on enter/exit */
.content[data-starting-style],
.content[data-ending-style] {
	opacity: 0;
	transform: translateY(-25%);
}

/* Sizes — .modal-xs/-sm/-lg/-xl/-full (md is the 600px default above) */
.sizeXs {
	width: var(--modal-xs);
}

.sizeSm {
	width: var(--modal-sm);
}

.sizeLg {
	width: var(--modal-lg);
}

.sizeXl {
	width: var(--modal-xl);
}

.sizeFull {
	width: var(--modal-full);
}

/*
* Variation — a 6px coloured left edge on the card mapped to global tokens.
* The card already carries a 5px border-radius, so the rounded corners
* are preserved behind the border.
*/
.variationProjectTimeBillable {
	border-left: 6px solid var(--color-billable);
}

.variationProjectTimeNotBillable {
	border-left: 6px solid var(--color-not-billable);
}

.variationDriveLogBusiness {
	border-left: 6px solid var(--color-business);
}

.variationDriveLogPrivate {
	border-left: 6px solid var(--color-private);
}

.variationAttendanceTime {
	border-left: 6px solid var(--color-attendance-time);
}

.variationPaidTimeOff {
	border-left: 6px solid var(--color-paid-time-off);
}

.variationUnpaidTimeOff {
	border-left: 6px solid var(--color-unpaid-time-off);
}

.variationVacation {
	border-left: 6px solid var(--color-vacation);
}

.variationSuspension {
	border-left: 6px solid var(--color-suspension);
}

.variationBreakTime {
	border-left: 6px solid var(--color-presence-board-break);
}

/* .modal-header — padding 20px, no bottom padding, no visible divider */
.header {
	position: relative;
	padding: var(--modal-title-padding) var(--modal-title-padding) 0;
}

.title {
	margin: 0;
	color: inherit;
}

.description {
	margin: 5px 0 0;
	color: #999;
}

/* .modal-body */
.body {
	position: relative;
	padding: var(--modal-inner-padding);
}

/* .modal-footer — padding 20px, no top padding, right-aligned actions with 5px gaps */
.footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 5px;
	padding: 0 var(--modal-inner-padding) var(--modal-inner-padding);
}

/* .close — text glyph button, top-right of the card */
.close {
	position: absolute;
	top: 15px;
	right: var(--modal-inner-padding);
	/*
	* Sits above the relatively-positioned header/body that follow it in the DOM,
	* otherwise those cover the button and swallow its clicks.
	*/
	z-index: 1;
	padding: 0;
	border: 0;
	border-radius: 3px;
	background: transparent;
	-webkit-appearance: none;
	appearance: none;
	font-size: calc(var(--font-size-base) * 1.5); /* 19.5px */
	font-weight: var(--close-font-weight);
	line-height: 1;
	color: var(--close-color);
	opacity: 0.6;
	cursor: pointer;
	transition: opacity 0.15s ease-in-out;
}

.close:hover,
.close:focus {
	opacity: 1;
	outline: 0;
}

.close:focus-visible {
	outline: 2px solid #648cff;
	outline-offset: 2px;
}
